import inViewport from 'in-viewport';
import Vue from 'vue';
import { trackBannerView } from '../../assets/js/lib/tracking';

export default (el) =>
  new Vue({
    el,
    mounted() {
      inViewport(this.$el, this.handleBannerViewTracking)
    },
    methods: {
      handleBannerViewTracking() {
        trackBannerView({
          id: this.$el.dataset.id,
          name: 'Quote with icons',
          component_name: document.body.dataset.origin + '/' + this.$el.dataset.module,
          ...(this.$el.dataset.siteSection && { site_section: this.$el.dataset.siteSection }),
          shopify_module_name: 'quote with icons'
        })
      }
    }
  });
